import {
  EHeadingStyleVariant,
  ETextStyleVariant,
  GeneralCurrencyDollarSignIcon,
  GeneralLinkIcon,
  GeneralTripsIcon,
  Heading,
  Text,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import MaxWidth from '@/components/common/layout/MaxWidth';

export const HowItWorks = () => {
  return (
    <div className="bg-canvas-100">
      <MaxWidth className="flex flex-col py-10 m-auto gap-6 md:gap-y-10 md:gap-x-0 md:grid md:grid-cols-3 md:grid-rows-[40px_1fr]">
        <Heading variant={EHeadingStyleVariant.H4} className="text-center md:col-start-2">
          <FormattedMessage defaultMessage="How it works" id="HK3ph8" />
        </Heading>

        <div className="flex flex-col md:flex-row gap-10 md:grid md:row-start-2 md:row-end-3 md:col-start-1 md:col-end-4 md:grid-cols-3 md:grid-rows-1">
          <div className="flex flex-col items-center text-center gap-2">
            <GeneralLinkIcon fontSize={24} />

            <Heading variant={EHeadingStyleVariant.H6}>
              <FormattedMessage defaultMessage="Share your link" id="iHV7p1" />
            </Heading>

            <Text variant={ETextStyleVariant.MediumRegular}>
              <FormattedMessage
                defaultMessage="Share your unique referral link or QR code with a friend."
                id="kRv1fz"
              />
            </Text>
          </div>

          <div className="flex flex-col items-center text-center gap-2">
            <GeneralTripsIcon fontSize={24} />

            <Heading variant={EHeadingStyleVariant.H6}>
              <FormattedMessage defaultMessage="Invite to book" id="cwSFfx" />
            </Heading>

            <Text variant={ETextStyleVariant.MediumRegular}>
              <FormattedMessage
                defaultMessage="Your friend gets $50 off their next trip of $200 or more."
                id="zJuPeu"
              />
            </Text>
          </div>

          <div className="flex flex-col items-center text-center gap-2">
            <GeneralCurrencyDollarSignIcon fontSize={24} />

            <Heading variant={EHeadingStyleVariant.H6}>
              <FormattedMessage defaultMessage="Save with credits" id="zrM/KU" />
            </Heading>

            <Text variant={ETextStyleVariant.MediumRegular}>
              <FormattedMessage
                defaultMessage="You'll earn $75 off your trip when they book theirs."
                id="+D5Z9h"
              />
            </Text>
          </div>
        </div>
      </MaxWidth>
    </div>
  );
};
